import eduboxLogo from "../assets/images/edubox_logo.png";
import t from "../locales";
import wifi from "../assets/icons/wifi.svg";
import clock from "../assets/icons/clock.svg";
import battery from "../assets/icons/battery.svg";

export default function Header() {
  return (
    <header className="header">
      <div className="header__upper">
        <img src={wifi} alt="" className="header__wifi" />
        <img src={clock} alt="" className="header__clock" />
        <img src={battery} alt="" className="header__battery" />
      </div>
      <div className="header__lower">
        <img className="header__logo" src={eduboxLogo} alt="Logo van edubox" />
        <p className="header__title">{t("header_title")}</p>
      </div>
    </header>
  );
}
